// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetMailboxPermissionRequest from '../contract/GetMailboxPermissionRequest';

export default function getMailboxPermissionRequest(
    data: GetMailboxPermissionRequest
): GetMailboxPermissionRequest {
    const result: GetMailboxPermissionRequest = {
        __type: 'GetMailboxPermissionRequest:#Exchange',
        ...data,
    };

    return result;
}
